import React from 'react';
import { IS_SERVER } from '../../constants';
import * as actions from '@store/actions';
import { auth } from '@modules/auth';

export const withUser = (WrappedPage) => {
  const render = ({ ...pageProps }) => <WrappedPage {...pageProps} />;

  render.getLayout = WrappedPage.getLayout;
  render.getInitialProps = async (ctx) => {
    const { store } = ctx;
    let userReadyPromise = Promise.resolve();

    if (IS_SERVER) {
      const POP_SESSION = auth.getAuthData({ ctx });
      const RT = auth.getAuthRt({ ctx });
      const { dispatch } = store;

      if (POP_SESSION || RT) {
        userReadyPromise = dispatch(actions.setUser());
        if (!WrappedPage.independentOfUser) {
          await userReadyPromise;
        }
      } else {
        dispatch(actions.removeUser());
      }
    }

    const componentProps = WrappedPage.getInitialProps && (await WrappedPage.getInitialProps(ctx));
    await userReadyPromise;
    return { ...componentProps, store };
  };

  return render;
};
